<template>
  <div style="width: 50%; margin: auto; display: flex">
    <div class="video-wrapper">
      <video ref="videoPlayer" class="embed video-js vjs-theme-sea"></video>
    </div>
  </div>
</template>

<script>
import videojs from "video.js";
import "video.js/dist/video-js.css";
import "@videojs/themes/dist/sea/index.css";
import youtube from "videojs-youtube";

export default {
  name: "VideoPlayer",

  props: {
    options: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  
  data() {
    return {
      player: null
    };
  },

  mounted() {
    this.player = videojs(
      this.$refs.videoPlayer,
      this.options,
      function onPlayerReady() {
      }
    );
  },

  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  }
};
</script>

<style>
  .video-wrapper {
    position: relative;
    overflow: hidden;
    width: 100%;
    padding-top: 56.25%;
    margin: auto;
  }
</style>